// @ts-nocheck
import axios, {AxiosRequestConfig} from "axios";
import qs from "qs";
import {BASE_URL} from "../redux/actions/dashboard/env.variables";
import * as jwtInstance from "./axiosJWTInstance";
import store from "../redux/store";
import {entriesToObj} from "./functions";

export interface Params {
    body: any,
    query: any
}

export const customAxiosGenerator = (caseKey = "jwt") => (serverUrl = BASE_URL) => {
    const cases = {
        "jwt": {
            requestHandler: (request: AxiosRequestConfig) => {
                const token = store.getState().auth.user?.token || localStorage.getItem("token");
                if (!token)
                    throw new Error("There is no jwt token");
                const query = setBodyAndQuery(request);
                request.url = `${serverUrl}${request.url}?${qs.stringify(query)}`;
                request.headers['Authorization'] = 'Bearer ' + token;
                return request;
            },
            successHandler: jwtInstance.successHandler,
            errorHandler: jwtInstance.errorHandler
        },
    }

    if (!cases.hasOwnProperty(caseKey)) {
        throw new Error(`
            param: $using must be 'jwt' for now
            got using = '${caseKey}' instead
            check .env file, path: axum-orders360/.env
        `);
    }

    const {requestHandler, successHandler, errorHandler} = cases[caseKey];

    const axiosInstance = axios.create({
        headers: { 'Cache-Control': 'no-cache' },
    });

    axiosInstance.interceptors.request.use(requestHandler);

    if (successHandler && errorHandler) {
        axiosInstance.interceptors.response.use(
            response => successHandler(response),
            error => errorHandler(axiosInstance)(error)
        );
    }

    return axiosInstance;
}

const setBodyAndQuery = (request: AxiosRequestConfig) => {
    const query = request.method === "get"
        ? request.query || {}
        : request.data.query || {};

    const flattened = Object.entries(query)
        .map(x => {
            const [k, v] = x;
            if (typeof v !== "number" && typeof v !== "string") {
                console.log(`'query' may only contain objects with primitive types. type of: ${k} -> ${typeof v}, applying .toString()`);
            }
            return [k, typeof v !== "number" && typeof v !== "string" ? v.toString() : v];
        });

    request.data = request.method === "get" ? null : {...request.data.body};

    return entriesToObj(flattened);
}

//por ahora solo se necesita case = jwt
export const customAxios = customAxiosGenerator();